import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchService(params) {
  return await request({
    url: ENDPOINT.HOME_SERVICE,
    method: "get",
    params,
  });
}

export async function fetchServiceById(id) {
  return await request({
    url: `${ENDPOINT.HOME_SERVICE}/${id}`,
    method: "get",
  });
}

export async function createService(data) {
  return await request({
    url: ENDPOINT.HOME_SERVICE,
    method: "post",
    data,
  });
}

export async function updateService(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_SERVICE}/${id}`,
    method: "put",
    data,
  });
}

export async function deleteService(id) {
  return await request({
    url: `${ENDPOINT.HOME_SERVICE}/${id}`,
    method: "delete",
  });
}